import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import api from "../lib/api";

export default function GalleryPage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");
  const [active, setActive] = useState(null);

  useEffect(() => {
    document.title = "Gallery — Faisal Car Bazar";
    api.get("/gallery").then((r) => setItems(r.data.items));
  }, []);

  const filtered = filter === "all" ? items : items.filter((i) => i.category === filter);

  return (
    <div data-testid="gallery-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="mb-10">
        <div className="eyebrow mb-4">Moments · {filtered.length}</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#F5F5DC] font-light">
          Showroom & <span className="text-[#DC143C] italic">delivery moments.</span>
        </h1>
        <div className="luxe-divider" />
      </div>

      <div className="flex gap-2 mb-8">
        {[
          { v: "all", l: "All" },
          { v: "showroom", l: "Showroom" },
          { v: "delivery", l: "Delivery Moments" },
        ].map((t) => (
          <button
            key={t.v}
            onClick={() => setFilter(t.v)}
            data-testid={`gallery-filter-${t.v}`}
            className={`px-5 py-2 rounded-full text-xs uppercase tracking-[0.2em] transition-all ${
              filter === t.v
                ? "bg-[#DC143C] text-white"
                : "border border-white/10 text-[#F5F5DC]/80 hover:bg-white/5"
            }`}
          >
            {t.l}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {filtered.map((item, i) => (
          <button
            key={item.id}
            onClick={() => setActive(item)}
            data-testid={`gallery-item-${i}`}
            className={`relative overflow-hidden rounded-xl group ${
              i % 5 === 0 ? "row-span-2 aspect-square md:aspect-auto md:row-span-2" : "aspect-square"
            }`}
          >
            <img
              src={item.image_url}
              alt={item.title}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
              <div className="text-left">
                <div className="text-[10px] uppercase tracking-[0.2em] text-[#D4AF37]">{item.category}</div>
                <div className="text-[#F5F5DC] font-display text-lg">{item.title}</div>
              </div>
            </div>
          </button>
        ))}
      </div>

      {active && (
        <div
          className="fixed inset-0 bg-black/90 z-[60] flex items-center justify-center p-6"
          onClick={() => setActive(null)}
          data-testid="lightbox-overlay"
        >
          <button
            onClick={() => setActive(null)}
            className="absolute top-6 right-6 w-12 h-12 rounded-full glass flex items-center justify-center text-[#F5F5DC] hover:bg-[#DC143C]"
            data-testid="lightbox-close"
          >
            <X size={20} />
          </button>
          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={active.image_url} alt={active.title} className="w-full max-h-[80vh] object-contain rounded-2xl" />
            <div className="mt-4 text-center">
              <div className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37]">{active.category}</div>
              <div className="font-display text-2xl text-[#F5F5DC] mt-1">{active.title}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
